import React from "react";
import { Card, Button } from "react-bootstrap";
import { Telephone, Geo } from "react-bootstrap-icons";
import './Card.css';


const Cards = ({ title, text, address, PhoneNumber, imgSrc, link, directionLink, bookingLink}) => {
    return (
        <Card style={{ width: '18rem' }}>
        <Card.Img variant="top" className="card-image" src={imgSrc} />
        <Card.Body>
          <Card.Title>{title}</Card.Title>
          <Card.Text>
            <Geo/> <a href={directionLink}> {address} </a>
            <br/>
            <Telephone/> {PhoneNumber}
          </Card.Text>
          <div class="btn-wrapper text-center d-flex justify-content-between">
            <Button className="button" href={link}>Website</Button>
            <Button className="button" href={directionLink}>Directions</Button>
            <Button className="button" href={bookingLink}>Booking</Button>
          </div>
        </Card.Body>
      </Card>
    )
 }

 export default Cards;
